export default __webpack_public_path__ + "static/media/bg.e2ea4837.jpg";